export default __webpack_public_path__ + "static/media/hbar.cf14c8a5.png";